// Optimistic result-entry verify toggle. Mirrors useMarkVerify: optimistic set +
// revert-on-error, hitting POST /result-entries/athlete/{userId}/{id}/verify
// which returns the updated row (no derived is_pr/is_sb — merge onto the row so
// the PR/SB badges survive the toggle). Staff/partner only — the caller gates on
// perms.canVerify.
import { useState } from 'react';
import axios from 'axios';

export default function useResultEntryVerify({ userId, apiUrl, getConfig, setEntries }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (e) => {
    const next = !e.verified;
    setBusyId(e.id);
    setEntries(list => list.map(x => (x.id === e.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/result-entries/athlete/${userId}/${e.id}/verify`, {}, getConfig());
      setEntries(list => list.map(x => (x.id === e.id ? { ...x, ...res.data } : x)));
    } catch {
      setEntries(list => list.map(x => (x.id === e.id ? { ...x, verified: e.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
